<template>
    <div class="clock_container">
        <header class="clock_header">
            <div>今日打卡</div>
            <div v-cloak>{{ date }}</div>
        </header>
        <main class="clock_main">
            <section class="main_top">  
                <div class="notclock" v-if="!isClock">
                    <div class="notclock_title">请判断下列问答，完成今日打卡</div>
                    <div class="checkbox">
                        <div class="item" v-for="(item,index) in optionList" :key="index">
                            <div v-cloak>{{ item.text }}</div>
                            <div>
                               <van-button type="default" :class="[item.checked ? 'checked' : '']" @click="onChecked(index,true)">是</van-button>
                               <van-button type="default" :class="[item.checked === false ? 'checked' : '']" @click="onChecked(index,false)">否</van-button>
                            </div>
                        </div>
                    </div>
                    <div class="notclock_btn">
                        <van-button class="confirm" color="#3BD3C1" @click="onConfirm()">确定</van-button>
                        <van-button class="share" icon="wechat" plain type="primary" @click="onShare()">分享家人代为打卡</van-button>
                    </div>
                </div>
                <div class="hasclock" v-else>
                    <img src="../../assets/img/clock/icon_done.png" alt="">
                    <div>已打卡</div>
                    <div>为了更好地保持孩子的视力，我们一起努力！</div>
                </div>
            </section>
            <section class="main_middle">
                <van-calendar   
                title="打卡日历"
                type="multiple"
                :poppable="false"
                :show-confirm="false"
                first-day-of-week="0"
                :formatter="formatter"
                :min-date="minDate" 
                :max-date="maxDate"
                :readonly="true"
                :style="{ height: '3.96rem' }" 
                color="#c0c0c0"
                row-height="0.54rem"/>
                <div class="record">
                    <div>
                        <div>
                            <div></div>
                            <span>累计打卡</span>
                        </div>
                        <span v-cloak>{{ clockData.clockDays }}<span>天</span></span>
                    </div>
                    <div>
                        <div>
                            <div></div>
                            <span>累计缺卡</span>
                        </div>
                        <span v-cloak>{{ clockData.noClockDays }}<span>天</span></span>
                    </div>
                </div>
            </section>
        </main>
        <div class="dialog" v-if="dialog" @click="onClose">
           <img src="../../assets/img/clock/tishi.png" alt="">
        </div>
        <div class="loading" v-if="show">
            <van-loading size="30px" vertical color="#3BD3C1">加载中...</van-loading>
        </div>
    </div>
</template>

<script>
import { getAppidApi } from "@/api/app";
import wx from "weixin-js-sdk";
import { getIsClockApi, confirmClockApi, getClockApi } from "../../api/clock";
import { getStudentId, getOpenId, getName } from "@/utils/auth.js";
export default {
  data() {
    return {
      show: true,
      isClock: false, //是否打卡
      clockData: {}, //打卡记录
      date: "",
      optionList: [
        {
          id: 0,
          text:
            "1、孩子每天在家使用电子产品累计时长不超过1小时，且每次小于15分钟；",
          checked: ""
        },
        {
          id: 1,
          text:
            "2、采取相关措施，来保证孩子学习阅读过程中的正确读写姿势，（如：提示坐姿或配备坐姿矫正器等）；",
          checked: ""
        },
        {
          id: 2,
          text:
            "3、家庭学习时使用专门护眼灯，护眼灯色温在3300K~5300K区间内（介于黄光与白光之间，具体可参照所购台灯的说明书参数）；",
          checked: ""
        },
        {
          id: 3,
          text:
            "4、家长督促孩子，遵循20-20-20护眼法，阅读书写每隔20分钟后目光看向20英尺（约6米）以外的任何物体连续眨眼20秒钟，能让眼睛得到很好的放松；",
          checked: ""
        },
        {
          id: 4,
          text:
            "5、孩子在家每天户外活动时间至少1小时或以上，放眼肌充分放松，吸收阳光带来的养份，补充多巴胺；",
          checked: ""
        },
        {
          id: 5,
          text: "6、孩子每天在家食用促进眼睛保护的食物（例如：鱼类、水果、绿色蔬菜；富含叶黄素、钙类、花青素等食物，如：菠菜、西兰花，牛奶、豆制品，蓝莓、葡萄、苹果等）；",
          checked: ""
        },
        {
          id: 6,
          text:
            "7、适当让眼睛做运动，简单易行，具体步骤包括：开合双眼（闭上眼睛四个节拍再张开眼睛）、十字运动（双眼左、右、上、下看）、双眼画圈（双眼逆时针、顺时针转动）、远近交替（手臂向前伸直，眼睛交替看拳头和远方）4节；",
          checked: ""
        },
        {
          id: 7,
          text: "8、即便孩子现在是好视力，您也能为孩子提前使用纯物理治疗的视力保护产品进行补充干预，让孩子每天放松眼肌提前做好视力储备，以便应对越来越长的用眼时间。",
          checked: ""
        }
      ],
      optionIds: "",
      minDate: null,
      maxDate: null,
      dialog: false,
      openId: getOpenId() || "",
      studentId: getStudentId() || "",
      studentName: getName() || ""
    };
  },
  created() {
    // let now = new Date(); //当前日期
    // let nowDayOfWeek = now.getDay(); //今天本周的第几天 
    // if(nowDayOfWeek == 5) {
    //   this.optionList = [
    //     {
    //       id: 0,
    //       text:
    //         "1. 学生在家使用电子产品累计时长不超过1小时，且每次小于15分钟；",
    //       checked: ""
    //     },
    //     {
    //       id: 1,
    //       text:
    //         "2. 学生今天户外活动时间是否达到1小时或以上，（不包括在校户外活动时间）；",
    //       checked: ""
    //     },
    //     {
    //       id: 2,
    //       text:
    //         "3. 学生在看书、阅读30~40分钟，是否放松眼睛5-10分钟以上，（望远、眼保健操或按摩等方式）；",
    //       checked: ""
    //     },
    //     {
    //       id: 3,
    //       text:
    //         "4. 家庭学习是否使用专门护眼灯，护眼灯色温在3300K~5300K区间内（介于黄光与白光之间，具体可参照所购台灯的说明书参数）；",
    //       checked: ""
    //     },
    //     {
    //       id: 4,
    //       text:
    //         "5. 学生今日在家是否食用促进眼睛保护的食物（例如：鱼类、水果、绿色蔬菜；富含叶黄素、钙类、花青素等食物，如：菠菜、西兰花，牛奶、豆制品，蓝莓、葡萄、苹果等）；",
    //       checked: ""
    //     },
    //     {
    //       id: 5,
    //       text: "6. 您是否严格控制孩子高糖、高油、高盐等食品及饮料的摄入量；",
    //       checked: ""
    //     },
    //     {
    //       id: 6,
    //       text:
    //         "7. 您是否采取相关措施，来保证孩子学习阅读过程中的正确读写姿势，（如：提示坐姿或配备坐姿矫正器等）；",
    //       checked: ""
    //     },
    //     {
    //       id: 7,
    //       text: "8. 您是否为孩子使用相应的视力保护产品或工具。",
    //       checked: ""
    //     }
    //   ]
    // } else {
    //   this.optionList = [
    //     {
    //       id: 0,
    //       text:
    //         "1. 学生在家使用电子产品累计时长不超过1小时，且每次小于15分钟；",
    //       checked: ""
    //     },
    //     {
    //       id: 1,
    //       text:
    //         "2. 学生今天户外活动时间是否达到1小时或以上，（不包括在校户外活动时间）；",
    //       checked: ""
    //     },
    //     {
    //       id: 2,
    //       text:
    //         "3. 学生在看书、阅读30~40分钟，是否放松眼睛5-10分钟以上，（望远、眼保健操或按摩等方式）；",
    //       checked: ""
    //     },
    //     {
    //       id: 3,
    //       text:
    //         "4. 家庭学习是否使用专门护眼灯，护眼灯色温在3300K~5300K区间内（介于黄光与白光之间，具体可参照所购台灯的说明书参数）；",
    //       checked: ""
    //     },
    //     {
    //       id: 4,
    //       text:
    //         "5. 学生今日在家是否食用促进眼睛保护的食物（例如：鱼类、水果、绿色蔬菜；富含叶黄素、钙类、花青素等食物，如：菠菜、西兰花，牛奶、豆制品，蓝莓、葡萄、苹果等）；",
    //       checked: ""
    //     },
    //     {
    //       id: 5,
    //       text: "6. 您是否严格控制孩子高糖、高油、高盐等食品及饮料的摄入量；",
    //       checked: ""
    //     },
    //     {
    //       id: 6,
    //       text:
    //         "7. 您是否采取相关措施，来保证孩子学习阅读过程中的正确读写姿势，（如：提示坐姿或配备坐姿矫正器等）；",
    //       checked: ""
    //     }
    //   ]
    // }
    //日历开始结束时间
    this.setMinMaxDate();
    //年月日
    this.addDate();
  },
  mounted() {
    //通过分享打卡进入页面
    let str = window.location.href;
    let clock = str.indexOf("clock");


    // let name = str.substring(str.indexOf("name=") + 5, str.length);
    // let openId = str.substring(str.indexOf("openId=") + 7, str.indexOf("&"));
    // //点击推送打卡异常消息
    // let openId2 = str.substring(str.indexOf('openId=') + 7,str.lastIndexOf('&'))
    // let studentId2 = str.substring(str.indexOf('studentId=') + 10,str.length)
    // let studentId = str.substring(
    //   str.indexOf("studentId=") + 10,
    //   str.lastIndexOf("&")
    // );
    if (
      clock != -1 && this.getQueryVariable("openId") && this.getQueryVariable("studentId") && this.getQueryVariable("name") && this.getQueryVariable('one')
    ) {
      this.openId = this.getQueryVariable("openId");
      this.studentId = this.getQueryVariable("studentId");
      this.getAppid2()
      this.getClockData();
    } else if(clock != -1 && this.getQueryVariable("openId") && this.getQueryVariable("studentId") && this.getQueryVariable("name")) {
      this.openId = this.getQueryVariable("openId");
      this.studentId = this.getQueryVariable("studentId")
      this.getAppid2()
      this.getClockData();
    } else {
      //微信jssdk
      this.getAppid();
      this.getClockData();
    }
  },
  methods: {
    getQueryVariable(variable) {
      var s = window.location.href
      var query = s.substring(s.indexOf('?') + 1, s.length);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) { 
              return pair[1]; 
          }
      }
      return (false);
    },
    async getAppid() {//正常分享link:"url+参数"
      //获取权限验证配置
      // encodeURIComponent()

      let currentUrl = window.location.href.split("#")[0];
      if (window.__wxjs_is_wkwebview) {
        // IOS
        if (window.entryUrl == "" || window.entryUrl == undefined) {
          window.entryUrl = currentUrl; // 将后面的参数去除
        }
      }
      let r = await getAppidApi({ url: currentUrl });
      let { appId, timestamp, nonceStr, signature, jsApiList } = r.data;

      //通过config接口注入权限验证配置
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名
        jsApiList: jsApiList // 必填，需要使用的JS接口列表
      });
      let that = this;
      wx.ready(function() {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
        // config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
        // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

        //判断当前客户端版本是否支持指定JS接口
        // wx.checkJsApi({
        //   jsApiList: ["scanQRCode", "onMenuShareAppMessage", "updateTimelineShareData"],
        //   success: function (res) {
        //     // console.log(res)
        //   }
        // });
        //分享给朋友
        wx.updateAppMessageShareData({
          title: "近视防控-请您代为打卡", // 分享标题
          desc: "今天太忙了，孩子今天的用眼情况如何，请帮忙代为打卡。", // 分享描述
          link: `${window.location.href}?openId=${that.openId}&studentId=${
            that.studentId
          }&name=${encodeURI(that.studentName)}&one=${123}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://static.qn.iouou.cn/daka_icon.png", // 分享图标
          success: function(res) {
            // 用户点击了分享后执行的回调函数
          }
        });
        //分享到朋友圈
        wx.updateTimelineShareData({
          title: "近视防控-请您代为打卡", // 分享标题
          link: `${window.location.href}?openId=${that.openId}&studentId=${
            that.studentId
          }&name=${encodeURI(that.studentName)}&one=${123}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://static.qn.iouou.cn/daka_icon.png", // 分享图标
          success: function() {
            // 设置成功
          }
        });
      });
      wx.error(function(res) {
        //  console.log(res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    },
    async getAppid2() {//分享后再分享link:"url"
      //获取权限验证配置
      // encodeURIComponent()

      let currentUrl = window.location.href.split("#")[0];
      if (window.__wxjs_is_wkwebview) {
        // IOS
        if (window.entryUrl == "" || window.entryUrl == undefined) {
          window.entryUrl = currentUrl; // 将后面的参数去除
        }
      }
      let r = await getAppidApi({ url: currentUrl });
      let { appId, timestamp, nonceStr, signature, jsApiList } = r.data;

      //通过config接口注入权限验证配置
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名
        jsApiList: jsApiList // 必填，需要使用的JS接口列表
      });
      let that = this;
      wx.ready(function() {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
        // config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
        // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

        //判断当前客户端版本是否支持指定JS接口
        // wx.checkJsApi({
        //   jsApiList: ["scanQRCode", "onMenuShareAppMessage", "updateTimelineShareData"],
        //   success: function (res) {
        //     // console.log(res)
        //   }
        // });
        //分享给朋友
        wx.updateAppMessageShareData({
          title: "近视防控-请您代为打卡", // 分享标题
          desc: "今天太忙了，孩子今天的用眼情况如何，请帮忙代为打卡。", // 分享描述
          link: `${window.location.href}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://static.qn.iouou.cn/daka_icon.png", // 分享图标
          success: function(res) {
            // 用户点击了分享后执行的回调函数
          }
        });
        //分享到朋友圈
        wx.updateTimelineShareData({
          title: "近视防控-请您代为打卡", // 分享标题
          link: `${window.location.href}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://static.qn.iouou.cn/daka_icon.png", // 分享图标
          success: function() {
            // 设置成功
          }
        });
      });
      wx.error(function(res) {
        //  console.log(res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    },
    async getClockData() {
      let nowDate = new Date(); //当前日期
      let year = nowDate.getFullYear(); //当前年
      let month = nowDate.getMonth() + 1; //当前月
      //判断是否打卡
      await getIsClockApi({
        openId: this.openId,
        studentId: this.studentId
      }).then(res => {
        this.isClock = res.data.isClockIn;
      });

      //获取打卡记录
      await getClockApi({
        openId: this.openId,
        studentId: this.studentId,
        year,
        month
      }).then(res => {
        this.clockData = JSON.parse(JSON.stringify(res.data));
      });
      this.show = false;
    },
    onChecked(index, is) {
      this.optionList[index].checked = is;
    },
    //打卡
    onConfirm() {
      console.log('打卡')
     // let now = new Date(); //当前日期
    //  let nowDayOfWeek = now.getDay(); //今天本周的第几天
    //  let dayOfMonth = now.getDate();
    //  if (nowDayOfWeek != 6) {
   //     this.$dialog.alert({ message: "每个月的第一个周六才可以打卡哦！" });
   //     return;
  //    } else if (dayOfMonth > 7) {
  //      this.$dialog.alert({ message: "每个月的第一个周六才可以打卡哦！" });
  //      return;
  //    }
      let num = this.optionList.filter(v => {
        return v.checked === "";
      }).length;

      if (num) {
        this.$toast({
          type: "fail",
          message: "请完成以上问答"
        });
        return;
      }
      let arr = [];
      this.optionList.forEach(v => {
        v.checked && arr.push(v.id);
      });
      this.optionIds = arr.join(",");

      confirmClockApi({
        openId: this.openId,
        studentId: this.studentId,
        optionIds: this.optionIds
      }).then(res => {
        this.$toast({
          type: "success",
          message: "打卡成功",
          onClose: () => {
            this.optionIds = "";
            window.location.reload();
          }
        });
      })
    },
    //分享家人代为打卡
    onShare() {
      this.dialog = !this.dialog;
    },
    //关闭遮罩层
    onClose() {
      this.dialog = false;
    },
    //获取当前年月日
    addDate() {
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      };
      this.date = `${date.year}年${date.month}月${date.date}日`;
    },
    //日历>是否已打卡
    formatter(day) {
      let nowDate = new Date();
      let date = {
        //当前年月日
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      };

      if (day.text <= date.date) {
        day.type = "selected"; //默认全部未打卡

        let clockList = this.clockData.clockList;
        if (clockList && clockList.length) {
          clockList.forEach(v => {
            let text = v.date.slice(v.date.lastIndexOf("-") + 1);

            if (day.text == text) {
              day.className = "noselected"; //打卡
            }
          });
        }
      }

      return day;
    },
    //设置日历的开始时间和结束时间
    setMinMaxDate() {
      let nowDate = new Date(); //当前日期
      let year = nowDate.getFullYear(); //当前年
      let month = nowDate.getMonth(); //当前月
      //本月的开始时间
      this.minDate = new Date(year, month, 1);
      //本月的结束时间
      this.maxDate = new Date(year, month + 1, 0);
    }
  }
};
</script>

<style scoped>
[v-cloak] {
  display: none !important;
}

.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #f5f5f5;
  z-index: 99999;
}

.loading > .van-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.dialog {
  width: calc(100vw - 1.34rem);
  height: calc(100vh - 2.26rem);
  padding: 0.68rem 0.49rem 1.58rem 0.85rem;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog > img {
  width: 100%;
  height: 100%;
}

.clock_container {
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

.clock_header {
  height: 1.3rem;
  border-radius: 0 0 0.2rem 0.2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #3bd3c1 url(../../assets/img/clock/record.png) no-repeat center;
  background-position-y: 0.1rem;
}

.clock_header > div:first-child {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.24rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.clock_header > div:nth-child(2) {
  padding-top: 0.02rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.clock_main {
  width: 100%;
  position: absolute;
  top: 1.04rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.main_top {
  margin: 0 auto;
}

.notclock {
  width: calc(100vw - 0.2rem);
  background-color: #ffffff;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: column;
}

.notclock_title {
  height: 0.42rem;
  display: flex;
  align-items: center;
  border-bottom: 0.01rem solid #f5f5f5;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #3bd3c1;
  letter-spacing: 0;
  font-weight: 400;
  text-indent: 0.2rem;
}

.checkbox {
  padding: 0 0.2rem;
}

.item {
  padding: 0.12rem 0 0.15rem 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 0.01rem solid #f5f5f5;
}

.item > div:first-child {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.14rem;
  color: #8a8a8a;
  letter-spacing: 0;
  line-height: 18px;
  font-weight: 400;
}

.item > div:last-child {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.08rem;
}

.item > div:last-child > button {
  width: 0.7143rem;
  height: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.01rem solid #3bd3c1;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.14rem;
  color: #8a8a8a;
  letter-spacing: 0;
  font-weight: 400;
  border-radius: 0.04rem;
}

.item > div:last-child > button:last-child {
  margin-left: 0.0714rem;
}

.item > div:last-child > button.checked {
  background-color: #3bd3c1;
  color: #ffffff;
}

.notclock_btn {
  height: 1.06rem;
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.notclock_btn > .van-button {
  height: 0.48rem;
  border-radius: 0.1rem;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.16rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}

.notclock_btn > .van-button.share {
  color: #3bd3c1;
  margin-top: 0.1rem;
  border-color: #3bd3c1;
}

.hasclock {
  width: calc(100vw - 0.96rem);
  padding: 0 0.38rem;
  height: 2.28rem;
  background: #ffffff;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hasclock > img {
  width: 0.6rem;
  height: 0.6rem;
  margin-top: 0.3rem;
}

.hasclock > div:nth-child(2) {
  margin: 0.08rem 0 0.25rem 0;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.18rem;
  color: #707070;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.hasclock > div:nth-child(3) {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.2rem;
  color: #3bd3c1;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.main_middle {
  width: calc(100vw - 0.2rem);
  margin: 0.1rem auto 0.29rem;
  background-color: #ffffff;
  border-radius: 0.2rem;
  position: relative;
}

.record {
  width: calc(100% - 0.4rem);
  position: absolute;
  top: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 0.1rem 0.1rem;
  padding: 0 0.2rem;
}

.record > div {
  width: 0.8rem;
  height: 0.45rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.record > div > div:first-child {
  display: flex;
  justify-content: center;
  align-items: center;
}

.record > div > div:first-child > div:first-child {
  width: 0.08rem;
  height: 0.08rem;
  border-radius: 50%;
  background-color: #3bd3c1;
  margin-right: 0.04rem;
}

.record > div:nth-child(2) > div:first-child > div:first-child {
  background-color: #e0edeb;
}

.record > div > div:first-child > span:nth-child(2) {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #707070;
  font-weight: 400;
}

.record > div > span:nth-child(2) > span {
  font-size: 0.12rem;
}

.record > div:first-child > span:nth-child(2) {
  font-family: SourceHanSansCN-Medium;
  font-size: 0.18rem;
  color: #3bd3c1;
  line-height: 0.18rem;
  font-weight: 500;
}

.record > div:nth-child(2) > span:nth-child(2) {
  font-family: SourceHanSansCN-Medium;
  font-size: 0.18rem;
  color: #b7ceca;
  line-height: 0.18rem;
  font-weight: 500;
}

.main_middle >>> .van-calendar {
  border-radius: 0.2rem;
}

.van-calendar >>> .van-calendar__header {
  box-shadow: 0 0 0 transparent;
}

.van-calendar >>> .van-calendar__header-title {
  line-height: 0.6rem;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.18rem;
  color: #505050;
  text-align: center;
  font-weight: 500;
}

.van-calendar >>> .van-calendar__header-subtitle {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.14rem;
  color: #505050;
  text-align: center;
  font-weight: 400;
}

.van-calendar >>> .van-calendar__weekdays {
  box-shadow: 0 0.05rem 0.05rem rgb(125 126 128 / 16%);
}

.van-calendar >>> .van-calendar__selected-day {
  width: 0.32rem !important;
  height: 0.32rem !important;
  border-radius: 50% !important;
  background: #e0edeb !important;
}

.van-calendar >>> .noselected .van-calendar__selected-day {
  background-color: #3bd3c1 !important;
}
</style>